import {
  Component,
  OnInit,
  Input,
  ElementRef,
  ViewChild,
  AfterViewInit,
  EventEmitter,
  Output
} from '@angular/core';

@Component({
  selector: 'jep-button',
  templateUrl: './jep-button.component.html',
  styleUrls: ['./jep-button.component.scss']
})
export class JepButtonComponent implements OnInit, AfterViewInit {
  @Input() text: string;
  @Input() isLoading: boolean;
  @Input() type: string;
  @Input() size: string;
  @Input() color: string;
  @Input() routerLink: string;
  @Input() icon: string;
  @Input() align: string;
  @Input() disabled: boolean;
  @Input() buttonType: string;
  @Input() width: string;
  @Input() height: string;
  @Input() light: string;
  @Output() isClicked = new EventEmitter();
  @ViewChild('button') button: any;

  constructor() { }

  ngOnInit() { }

  ngAfterViewInit() {
    var elem_button = this.button._elementRef.nativeElement;
    this.addDefaultClass(elem_button);
    this.addButtonSizeClass(elem_button, this.size);
    this.addButtonCustomTypeClass(elem_button, this.type);
    this.setButtonWidth(elem_button, this.width);
    this.setButtonHeight(elem_button, this.height);
  }

  addButtonSizeClass(elem, size) {
    if (size) {
      elem.classList.add('button--' + this.size);
    }
  }

  addDefaultClass(elem) {
    elem.classList.add('button');
  }

  addButtonCustomTypeClass(elem, type) {
    if (type) {
      elem.classList.add('button--' + this.type);
    }
  }

  setButtonWidth(elem, width) {
    if (width) {
      elem.style.width = width + 'px';
    }
  }
  setButtonHeight(elem, height) {
    if (height) {
      elem.style.height = height + 'px';
    }
  }
}
